import { DATA_TABLE_SOURCE_HOUSEHOLD_LISTINGS } from 'common/dataTableConstants';

import {
  dataTableGetBranchParams,
  actionDataTableLoadItemsIfNotFullyLoaded,
  actionInitializeDataTableState,
} from 'client/helpers/dataTables';

export default async function getHouseholdListing({ state, apiClient }, { householdListingId }) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_HOUSEHOLD_LISTINGS,
    viewId: `by-household-listing-id-${householdListingId}`,
    count: 1,
    injectSingleItem: true,
    customParams: {
      householdListings: {
        householdListingId,
      },
    },
  };

  actionInitializeDataTableState({ state, apiClient }, dataTableSettings);
  await actionDataTableLoadItemsIfNotFullyLoaded({ state, apiClient }, dataTableSettings);

  const branchParams = dataTableGetBranchParams(dataTableSettings)();
  const watcher = state.watch(branchParams);
  const { items } = watcher.get();
  watcher.release();

  return items[0];
}
